import React, { useState } from "react";
import { config } from "../config/config";
import { Grid, Container, Divider } from "@material-ui/core";
import EnvironmentFilter from "../components/Filters/EnvironmentFilter";
import {
  Button,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
const Compare = () => {
  const [appliedFilters, setAppliedFilters] = useState({});
  const [envDiff, setEnvDiff] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("Start by choosing two environments to compare from the drop downs above.");
  const handleFilterChange = (e) => {
    let name = e.target.name;
    setAppliedFilters((prevState) => ({
      ...prevState,
      [name]: e.target.value,
    }));
  };

  const getEnvironmentDiff = () => {
    setIsLoading(true);
    const envIn = appliedFilters.envIn;
    const envNotIn = appliedFilters.envNotIn;

    fetch(config.API_URL + `/Environment/diff?isIn=${envIn}&notIn=${envNotIn}`)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
          if(data.length === 0) {
              setStatusMessage("We have found no differences between the two environments");
          }
        setEnvDiff(data);
        setIsLoading(false);
      });
  };
  return (
      <div>
    <Container maxWidth="xl">
      <Grid container style={{ marginTop: "75px" }}>
        <Grid item xs={12}>
          <Typography variant="h4" style={{ display: "inline-block" }}>
            Compare
          </Typography>
          <Divider />
          <br>
        </br>
        <br>
        </br>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">
            Show me all releases deployed in{" "}
            <EnvironmentFilter
              name="envIn"
              onChange={(e) => handleFilterChange(e)}
            />{" "}
            not deployed in{" "}
            <EnvironmentFilter
              name="envNotIn"
              onChange={(e) => handleFilterChange(e)}
            />
            <Button onClick={() => getEnvironmentDiff()}>Compare</Button>
          </Typography>
          <br>
        </br>
        <br>
        </br>
        </Grid>

        <Grid item xs={12}>
          {isLoading && <LinearProgress style={{ margin: "0 auto" }} />}

          {envDiff.length > 0 && (
            <Table>
              <TableHead>
                <TableRow>
                    <TableCell>Project</TableCell>
                  <TableCell>Application</TableCell>
                  <TableCell>Version</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {envDiff.map((e, i) => {
                  return (
                    <TableRow key={i}>
                        <TableCell>{e.project}</TableCell>
                      <TableCell>{e.app_name}</TableCell>
                      <TableCell>{e.version_num}</TableCell>
                      <TableCell>
                        {" "}
                        <Button
                          color="primary"
                          variant="outlined"
                          size="small"
                          onClick={() =>
                            window.open(
                              `${config.DEVOPS_ORG_URL}/${e.project}/_build/results?buildId=${e.ado_build_id}&view=results`
                            )
                          }
                          style={{ margin: "5px" }}
                        >
                          Go To Build
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}

          {envDiff.length === 0 && (
            <Typography>
              {statusMessage}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Container>
    </div>
  );
};
export default Compare;
